import { Document } from '@/types';
import { PasseriniAPI } from './apiService';

export class DocumentsService {
  /**
   * Obtiene todos los documentos de un trámite
   */
  static async getDocuments(tramiteId: number): Promise<Document[]> {
    try {
      const response = await PasseriniAPI.get(`/tramites/${tramiteId}/documents`);
      return response.data;
    } catch (error) {
      console.error('Error fetching documents:', error);
      throw error;
    }
  }

  /**
   * Sube un archivo como documento del trámite
   */
  static async uploadDocument(tramiteId: number, file: File): Promise<Document> {
    try {
      const formData = new FormData();
      formData.append('file', file);

      const response = await PasseriniAPI.post(
        `/tramites/${tramiteId}/documents`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error uploading document:', error);
      throw error;
    }
  }

  /**
   * Elimina un documento
   */
  static async deleteDocument(tramiteId: number, documentId: number): Promise<void> {
    try {
      await PasseriniAPI.delete(`/tramites/${tramiteId}/documents/${documentId}`);
    } catch (error) {
      console.error('Error deleting document:', error);
      throw error;
    }
  }

  /**
   * Descarga un documento
   */
  static async downloadDocument(tramiteId: number, documentId: number): Promise<Blob> {
    try {
      const response = await PasseriniAPI.get(
        `/tramites/${tramiteId}/documents/download/${documentId}`,
        {
          responseType: 'blob',
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error downloading document:', error);
      throw error;
    }
  }

  /**
   * Actualiza el nombre de un documento
   */
  static async updateDocumentName(tramiteId: number, documentId: number, name: string): Promise<Document> {
    try {
      const response = await PasseriniAPI.put(
        `/tramites/${tramiteId}/documents/${documentId}`,
        { name }
      );
      return response.data;
    } catch (error) {
      console.error('Error updating document name:', error);
      throw error;
    }
  }

  /**
   * Obtiene la URL de descarga de un documento
   */
  static getDownloadUrl(tramiteId: number, documentId: number): string {
    return `${PasseriniAPI.defaults.baseURL}/tramites/${tramiteId}/documents/download/${documentId}`;
  }
}

export default DocumentsService;
